import React from 'react';
import type { Event } from '@/features/events/types/types';

interface EventHeaderProps {
  eventInfo: Event;
}

const EventHeader: React.FC<EventHeaderProps> = ({ eventInfo }) => {
  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-8 py-12 lg:py-24">
      <header className="mb-20">
        <h1 className="text-5xl lg:text-7xl font-bold font-serif tracking-tight mb-4">
          {eventInfo.name}
        </h1>
        <p className="text-lg text-gray-300 max-w-2xl">
          {eventInfo.description}
        </p>
      </header>
    </div>
  );
};

export default EventHeader;
